import React from 'react'
import CategoryInput from 'sprockets_react/job_wizards/components/CategoryInput'
import LocationInput from 'sprockets_react/components/LocationInput'
import { Job, JobWizard, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

const GetQuotes = React.createClass({
  getInitialState: function() {
    return this.getCategorySuburb()
  },

  componentDidMount: function() {
    Job.Store.addChangeListener(this.updateState)
  },

  componentWillUnmount: function() {
    Job.Store.removeChangeListener(this.updateState)
  },

  getCategorySuburb: function() {
    return $.extend(Job.Store.getCategory(), Job.Store.getSuburb())
  },

  updateState: function(data) {
    this.setState(this.getCategorySuburb())
  },

  handleSelectedCategory: function( event, selected ) {
    event.preventDefault()
    Job.Actions.updateCategory(selected.item)
    Job.Actions.updateSubCategory(selected.item, 'add')
    Job.Actions.updateKeyword(selected.item.keyword)
  },

  handleCategoryOnChange: function(event) {
    Job.Actions.updateSubCategory({id: Job.Data.category_id, values: Job.Data.category}, 'remove')
    Job.Actions.updateCategory({ id: 0, value: event.target.value })
    Job.Actions.updateKeyword(null)
  },

  handleAutocompleteSelection: function( event, response ) {
    Job.Actions.updateLocation({ id: response.item.id, value: response.item.value })
  },

  handleLocationChange: function(event) {
    Job.Actions.updateLocation({ id: 0, value: event.target.value })
  },

  handleClick: function() {
    var showJobWizardModal = () => {
      if (jobLocationAutocompleteSelected() && categoryValuePresent()) {
        if (window.mobilecheck()) {
          advanceMobileWizardToNextStep()
        }
        else {
          advanceWizardToNextStep()
        }
      }

      $('#job-modal').modal({keyboard: false, backdrop: 'static'}, {cta: this.props.cta})

      function advanceWizardToNextStep() {
        let steps            = JobWizard.Steps
        let details          = JobWizard.Details
        let detailsStepIndex = details.detailsStepIndex(steps)
        let nextStep         = steps[detailsStepIndex + 1]

        if (nextStep === JobWizard.SubCategory && details.hasSubcategory()) {
          JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Description)
        } else {
          JobWizard.Emitter.emit('job:wizard:advanceToNextStep')
        }
      }

      function advanceMobileWizardToNextStep() {
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SelectCategory)
      }

      function jobLocationAutocompleteSelected() {
        return Job.Data.suburb_id !== 0
      }

      function categoryValuePresent() {
        return Job.Data.category.trim() !== ''
      }
    }

    showJobWizardModal()
  },

  selectExactMatchForSubcategory: function(callback) {
    $.ajax(SS.API.V3.subCategoriesGet({ 'filter[q]': this.searchTerm(), 'filter[prefer_keywords]': '1' })).done((response) => {
      const keyword = response.meta.keyword

      if (keyword) {
        let category = { id: keyword.subcategoryID, value: keyword.subcategoryName }
        Job.Actions.updateKeyword(keyword.value)
        Job.Actions.updateCategory(category)
        Job.Actions.updateSubCategory(category, 'add')
        JobWizard.Emitter.emit('job:wizard:categorySelected', null, { item: category })
      } else {
        for (let item of response.data) {
          if (this.searchTerm().toLowerCase() == item.attributes.name.toLowerCase()) {
            let category = { id: parseInt(item.id, 10), value: item.attributes.name }
            Job.Actions.updateCategory(category)
            Job.Actions.updateSubCategory(category, 'add')
            JobWizard.Emitter.emit('job:wizard:categorySelected', null, { item: category })
          }
        }
      }

      callback()
    })
  },

  searchTerm: function() {
    return $('input[name="category"]').val()
  },

  render: function() {
    return (
      <div className="row">
        {
          this.props.hideTextFieldsOnMobile === undefined || !window.mobilecheck() ?
            <div>
              <div className="col-md-12 col-sm-12 home-text-area pb10 category-input-container">
                <div className="text-center">
                  <CategoryInput
                    category={this.state.keyword || this.state.category}
                    handleSelectedCategory={this.handleSelectedCategory}
                    handleCategoryChange={this.handleCategoryOnChange}
                    preferKeywords="1"
                    guId={SS.utils.generateGuid()}
                  />
                </div>
              </div>
              <div className="col-md-12 col-sm-12 home-text-area pb10 location-input-container">
                <div className="text-center">
                  <LocationInput
                    suburb={this.state.suburb}
                    handleAutocompleteSelection={this.handleAutocompleteSelection}
                    handleLocationChange={this.handleLocationChange}
                    guId={SS.utils.generateGuid()}
                  />
                </div>
              </div>
            </div>
          : ''
        }
        <div className="col-sm-12 col-md-12 home-page-btn submit-container">
          <div className="mb0">
            <button className="btn btn-main btn-block submit-button btn-lg" onClick={this.handleClick}>Get Quotes</button>
          </div>
        </div>
      </div>
    )
  }
})

export default GetQuotes
